import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper } from "app/NativeComponents/common";

import BoxTabs from "./BoxTabs";
import NoteTextBox from "./NoteTextBox";
import MessageTextBox from "./MessageTextBox";
import KeyboardAwarePanel from "app/NativeComponents/components/KeyboardAwarePanel";

import {
  appRedirect,
  setEditModal,
  getTeamPhoneNumbers,
  setModal,
  toggleModal
} from "app/NativeActions";
class MessageAndNoteBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: props.box_tab ? props.box_tab : "note"
    };

    this.toggleTab = this.toggleTab.bind(this);
  }

  toggleTab(tab) {
    this.setState({
      tab
    });
  }

  renderHeader() {
    if (this.props.renderHeader) {
      return this.props.renderHeader();
    }
  }
  render() {
    return (
      <Wrapper>
        {this.renderHeader()}

        <Wrapper
          style={{
            backgroundColor:
              this.state.tab == "note"
                ? this.props.colors.yellow_card_color_muted
                : this.props.colors.card_color,

            paddingBottom:
              this.props.device != "desktop"
                ? this.props.platform == "android" || this.props.isIphoneX
                  ? 20
                  : 0
                : 0
          }}
        >
          <Wrapper
            style={{
              borderTopColor: this.props.colors.border_color,
              borderTopWidth: 1,
              borderTopStyle: "solid",
              paddingRight: this.props.device != "desktop" ? 5 : 0,
              paddingLeft: this.props.device != "desktop" ? 5 : 0
            }}
          >
            <BoxTabs
              tab={this.state.tab}
              toggleTab={this.toggleTab}
              colors={this.props.colors}
              include_tabs={this.props.include_tabs}
            />
            <NoteTextBox
              tab={this.state.tab}
              noteValue={this.props.noteValue}
              onSubmit={this.props.onNoteSubmit}
              onNoteChange={this.props.onNoteChange}
              disabled={this.props.disabled}
              {...this.props}
            />
            <MessageTextBox
              tab={this.state.tab}
              onSubmit={this.props.onMessageSubmit}
              messageValue={this.props.messageValue}
              onMessageChange={this.props.onMessageChange}
              onFromNumberChange={this.props.onFromNumberChange}
              renderMessageHeader={this.props.renderMessageHeader}
              selected_from_number={this.props.selected_from_number}
              toggleTab={this.toggleTab}
              selected_conversations={this.props.selected_conversations}
              disabled={this.props.disabled}
              {...this.props}
            />
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ auth, settings, native, message }) => {
  const { token, user } = auth;
  const { device, platform, isMobile, isIphoneX } = native;
  const { colors } = settings;

  const { team_phone_numbers_loading, team_phone_number_groups } = message;

  return {
    token,
    user,
    device,
    platform,
    isMobile,
    colors,
    isIphoneX,

    team_phone_numbers_loading,
    team_phone_number_groups
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  setEditModal,
  getTeamPhoneNumbers,
  setModal,
  toggleModal
})(MessageAndNoteBox);
